import { Suspense, lazy } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(() => import("../components/contactUs"));

const ContactUs = () => {
  return (
    <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
  )
}

export default ContactUs

